import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const uploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {},
});

export const {} = uploadSlice.actions;
export default uploadSlice.reducer;
